import axios from "axios";
import * as actions from "./actionsTypes";
import messages from "../messages";
import toastr from "toastr";
import jobpositionRelatedServices from "./jobpositionRelated.services";

toastr.options = {
  closeButton: false,
  debug: false,
  newestOnTop: false,
  progressBar: true,
  positionClass: "toast-top-right",
  preventDuplicates: false,
  onclick: null,
  showDuration: "300",
  hideDuration: "1000",
  timeOut: "5000",
  extendedTimeOut: "1000",
  showEasing: "swing",
  hideEasing: "linear",
  showMethod: "fadeIn",
  hideMethod: "fadeOut",
};

export const getJobpositionRelated = (filters) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_JOB_POSITION_RELATED,
      payload: true,
    });
    const resp = await jobpositionRelatedServices.getJobpositionRelated(filters);
    dispatch({
      type: actions.GET_JOB_POSITION_RELATED,
      payload: resp.data,
    });
    dispatch({
      type: actions.JOB_POSITION_RELATED_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          case 404:
            if(ex.response.data && ex.response.data.mensaje){
              message = ex.response.data.mensaje;
            }else{
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      }else{
        message = messages.networkError;
      }
    }else{
      message = messages.applicationError
    }
    dispatch({
      type: actions.JOB_POSITION_RELATED_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_JOB_POSITION_RELATED,
      payload: false,
    });
  }
};

// export const getJobpositionRelatedById = (id) => async (dispatch) => {
//   try {
//     dispatch({
//       type: actions.LOADING_JOB_POSITION_RELATED,
//       payload: true,
//     });
//     const resp = await jobpositionRelatedServices.getJobpositionRelatedById(id);
//     dispatch({
//       type: actions.GET_JOB_POSITION_RELATED,
//       payload: resp.data,
//     });
//     dispatch({
//       type: actions.JOB_POSITION_RELATED_FAIL,
//       payload: "",
//     });
//   } catch (ex) {
//     let message = null;
//     if (axios.isAxiosError(ex)) {
//       if (ex.response?.status) {
//         switch (ex.response.status) {
//           case 400:
//             message = ex.response.data.mensaje;
//             break;
//           case 404:
//             if(ex.response.data && ex.response.data.mensaje){
//               message = ex.response.data.mensaje;
//             }else{
//               message = messages.notFound;
//             }
//             break;
//           default:
//             message = messages.errorMessage;
//             break;
//         }
//       }else{
//         message = messages.networkError;
//       }
//     }else{
//       message = messages.applicationError
//     }
//     dispatch({
//       type: actions.JOB_POSITION_RELATED_FAIL,
//       payload: message,
//     });
//   } finally {
//     dispatch({
//       type: actions.LOADING_JOB_POSITION_RELATED,
//       payload: false,
//     });
//   }
// };

export const saveJobpositionRelated = (req, setShowModal) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.SAVE_LOADING_JOB_POSITION_RELATED,
      payload: true,
    });
    const resp = await jobpositionRelatedServices.saveJobpositionRelated(req);
    let { data, count } = getState().jobpositionRelated.jobpositionRelated;
    data = [...data, resp.data];
    dispatch({
      type: actions.GET_JOB_POSITION_RELATED,
      payload: {
        data: data,
        count: count + 1,
      },
    });
    dispatch({
      type: actions.FORM_FAIL,
      payload: "",
    });
    setShowModal(false)
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            if(ex.response.data.mensaje){
              message = ex.response.data.mensaje;
            }else{
              message = messages.errorMessage + " " + ex.response.statusText;
            }
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.FORM_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.SAVE_LOADING_JOB_POSITION_RELATED,
      payload: false,
    });
  }
};

export const editJobpositionRelated = (req, id, index, setShowModal, setIsDisable) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_JOB_POSITION_RELATED,
      payload: true,
    });
    const resp = await jobpositionRelatedServices.editJobpositionRelated(id, req);
    const { data, count } = getState().jobpositionRelated.jobpositionRelated;
    data[index] = resp.data;
    dispatch({
      type: actions.GET_JOB_POSITION_RELATED,
      payload: {
        data: data,
        count: count,
      },
    });
    dispatch({
      type: actions.FORM_FAIL,
      payload: "",
    });
    setShowModal(false)
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.FORM_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_JOB_POSITION_RELATED,
      payload: false,
    });
  }
};

export const deleteJobpositionRelated = (id, index) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_JOB_POSITION_RELATED,
      payload: true,
    });
    await jobpositionRelatedServices.deleteJobpositionRelated(id);
    const { data, count } = getState().jobpositionRelated.jobpositionRelated;
    data.splice(index, 1);
    dispatch({
      type: actions.GET_JOB_POSITION_RELATED,
      payload: {
        data: data,
        count: count - 1,
      },
    });
    dispatch({
      type: actions.JOB_POSITION_RELATED_FAIL,
      payload: "",
    });
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.JOB_POSITION_RELATED_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_JOB_POSITION_RELATED,
      payload: false,
    });
  }
};
